import { TextField, Box } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const ConfirmationLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "date" || key === "confirmation_date") {
            value = formatDateForStorage(value);
        }
        
        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Date"
                        fullWidth
                        slotProps={{
                            inputLabel: { shrink: true },
                        }}
                        value={data.date ? formatDateForInput(data.date) : ""}
                        onChange={(e) => handleChange("date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="Employee ID"
                        fullWidth
                        value={data.employee_id || ""}
                        onChange={(e) => handleChange("employee_id", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                        extraOptions={["Trainee"]}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Confirmation Date"
                        fullWidth
                        slotProps={{
                            inputLabel: { shrink: true },
                        }}
                        value={data.confirmation_date ? formatDateForInput(data.confirmation_date) : ""}
                        onChange={(e) => handleChange("confirmation_date", e.target.value)}
                    />
                </Box>

            </Box>
        </Box>
    );
};

export default ConfirmationLetterForm;
